import React, {useEffect, useMemo} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import Team from '../../components/team/Team';
import pages from '../../content/pages.json';
import {useSiteConfig} from '../../data/ConfigContext';
import {usePageMeta} from '../../seo/usePageMeta';
import {slugify, teamPath} from '../../utils/slug';
import {NotFoundContent} from '../notfound/NotFound';

const Teams = () => {
    const {slug = ''} = useParams();
    const navigate = useNavigate();
    const config = useSiteConfig();
    // older links used the internal name ("/teams/BL%20Herren")
    const team = config?.tables.find(table => slugify(table.internal_name) === slug || table.internal_name === slug);
    const players = useMemo(
        () => (team && config ? config.players.filter(player => player.team === team.internal_name) : []),
        [config, team]);

    useEffect(() => {
        if (team && slug !== slugify(team.internal_name)) navigate(teamPath(team.internal_name), {replace: true});
    }, [team, slug, navigate]);

    usePageMeta(team
        ? {title: team.name, description: pages.team.description.replaceAll('{team}', team.name)}
        : config ? {title: 'Seite nicht gefunden', noindex: true} : {title: 'Teams'});

    if (config && !team) return <NotFoundContent/>;

    return (
        <div className="page">
            <h1 className="page-title">{team?.name ?? 'Teams'}</h1>
            {!team ? (
                <div className="player-grid" aria-hidden="true">
                    {Array.from({length: 8}, (_, i) => <div key={i} className="player-skeleton skeleton"/>)}
                </div>
            ) : players.length ? (
                <Team key={team.internal_name} players={players}/>
            ) : (
                <p className="empty-state">Der Kader für dieses Team ist noch nicht eingetragen.</p>
            )}
        </div>
    );
};

export default Teams;
